<section class="main">
    <header class="panel-heading">
        <h2 class="main-title">Admin Panel</h2>
        <span class="user-count" aria-live="polite">{{ userService.allUsers().length }} {{ userService.allUsers().length === 1 ? 'user' : 'users' }}</span>
    </header>
    <div class="table-container">
        <table>
            <thead><tr>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone Number</th>
                <th scope="col">Registration Date</th>
                <th scope="col">Enabled</th>
                <th scope="col">Authority</th>
                <th scope="col">Actions</th>
            </tr></thead>
            <tbody>
            @for (element of userService.allUsers(); track element.id) {
                <tr class="body-columns">
                    <td data-label="First Name" class="name-cell">{{ element.firstName }}</td>
                    <td data-label="Last Name" class="name-cell">{{ element.lastName }}</td>
                    <td data-label="Email" class="email-cell">{{ element.email }}</td>
                    <td data-label="Phone Number">{{ element.phoneNumber || '—' }}</td>
                    <td data-label="Registration Date">{{ element.registrationDate || '—' }}</td>
                    <td data-label="Enabled">
                        <select name="status" class="custom-select" (change)="changeUserStatus(element, $event)"
                                [class.status-active]="element.enabled"
                                [attr.aria-label]="'Status for ' + element.firstName + ' ' + element.lastName"
                                [disabled]="isCurrentUser(element.id) || !isSuperAdmin()">
                            @for (option of userService.user_status(); track option) {
                                <option [selected]="option === userService.getUserStatus(element)" [value]="option">{{ option }}</option>
                            }
                        </select>
                    </td>
                    <td data-label="Authority">
                        <select name="authority" class="custom-select"
                                (change)="changeUserRole(element, $event)"
                                [attr.aria-label]="'Authority for ' + element.firstName + ' ' + element.lastName"
                                [disabled]="isCurrentUser(element.id) || !isSuperAdmin()">
                            @for (option of userService.input_options(); track option) {
                                <option [selected]="option === userService.getUserRole(element)" [value]="option">{{ option }}</option>
                            }
                        </select>
                    </td>
                    <td data-label="Actions" class="actions">
                        <button type="button" class="action-btn" (click)="editUserDetails(element.id)"
                                [attr.aria-label]="'Edit ' + element.firstName + ' ' + element.lastName" title="Edit user">
                            <i class="bi bi-pencil" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="mfa-enabled-btn" (click)="disableUserMfa(element.id, false)"
                                [disabled]="!element.mfaEnabled || element.id === userService.loggedUser().id"
                                [attr.aria-label]="'Clear MFA for ' + element.firstName + ' ' + element.lastName">Clear MFA</button>
                    </td>
                </tr>
            } @empty {
                <tr><td colspan="8" class="empty-state">No users available.</td></tr>
            }
            </tbody>
        </table>
    </div>
</section>
